import React, { useState, useContext, useEffect } from "react";
import styles from "./index.module.scss";
import { FeedbackQuestions } from "./FeedbackQuestions";
import close from "../../../../assets/images/close.png";
import { webinarContext } from "../../../../contexts/WebinarContext/WebinarContextProvider";
import { FEEDBACK_SUBMIT } from "../../../../AppConstants/AnalyticsEventName";
import { useParams } from "react-router-dom";
import ScoreManager from "../../../../Managers/ScoringManager/post";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import { showToast } from "../../../../utils/common.utils";
import { WEBINAR_FEEDBACK_SUBMIT_EVENT } from "../../../../Clevertap/EventNames.ts";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { getWebinarClickData } from "../../../../Clevertap/EventHandler.ts";

function Feedback({
  webinarData,
  showFeedback,
  addClickAnalytics,
  handleFeedbackClose,
}) {
  const { webinarID } = useParams();
  const { user } = useContext(UserContext);
  const { addCleverTapAnalytics } = useContext(AnalyticsContext);

  const { createUserFeedback } = useContext(webinarContext);

  const [selectedOption, setSelectedOption] = useState([]);

  useEffect(() => {
    if (!showFeedback) {
      setSelectedOption([]);
    }
  }, [showFeedback]);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (selectedOption.length < 4) {
        showToast("Please select all the options.");
        return;
      }
      addClickAnalytics(FEEDBACK_SUBMIT);
      addCleverTapAnalytics(
        WEBINAR_FEEDBACK_SUBMIT_EVENT,
        getWebinarClickData(webinarData)
      );
      handleFeedbackClose();
      let isSucceess = await createUserFeedback(webinarID, selectedOption);
      if (!isSucceess) {
        showToast("You have already submitted feedback");
        return;
      }
      //Webinar feedback points removed for new loyality points S-1689
    //   ScoreManager.giveFeedbackPoints(user.uid, webinarID);
      showToast("Feedback submitted successfully");
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (type, id, option) => {
    switch (type) {
      case "radio":
        setSelectedOption((prev) => {
          let newArray = [];
          // Find items that already exists in array
          const findExistingItem = prev.find((item) => {
            return item.id === id;
          });

          if (findExistingItem) {
            // Remove found Item
            let filteredArray = prev.filter(
              (item) => item.id !== findExistingItem.id
            );
            // set the state with new values/object
            newArray = [
              ...filteredArray,
              {
                id: id,
                value: option,
              },
            ];
          } else {
            // if new Item is being added
            newArray = [
              ...prev,
              {
                id: id,
                value: option,
              },
            ];
          }
          return newArray;
        });
        break;
      default:
        return;
    }
  };

  return (
    <>
      {showFeedback && (
        <div onClick={handleFeedbackClose} className={"modalOverlayWithTint"} />
      )}
      <form onSubmit={handleSubmit}>
        <div
          className={`${styles.feedback} ${
            showFeedback ? styles.show : styles.hide
          }`}
        >
          <div className={styles.feedbackTitle}>Feedback</div>
          <div onClick={handleFeedbackClose} className={styles.feedbackClose}>
            <img src={close} alt="Close" />
          </div>
          <div className={styles.qtnsWrapper}>
            {React.Children.toArray(
              FeedbackQuestions.map((questions, index) => {
                return (
                  <div className={styles.Qtns}>
                    {index + 1}) {questions.question}
                    {questions.type === "radio" ? (
                      <div className={styles.optns}>
                        {questions.options.map((option, index) => (
                          <label
                            key={`${option}_${index}`}
                            className="custom-radiobtn"
                          >
                            {option}
                            <input
                              onChange={(e) => {
                                handleChange(
                                  questions.type,
                                  questions.id,
                                  option
                                );
                              }}
                              type={questions.type}
                              value={option}
                              name={questions.question}
                            />
                            <span className="custom-radiobtn-checked"></span>
                          </label>
                        ))}
                      </div>
                    ) : null}
                  </div>
                );
              })
            )}
          </div>

          <div className={styles.feedbackSubmit}>
            <button type="submit" className={`btn`}>
              Submit
            </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default Feedback;
